import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import MdArrowBack from '@meronex/icons/md/MdArrowBack';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';

import { useHistory } from 'react-router-dom';

import FaBell from '@meronex/icons/fa/FaBell';

import { App } from '../../base/AppContext';

import PulseIndicator from '../../components/core/PulseIndicator';
import NotificationsDialog from '../notifications/NotificationsDialog';
import SettingsMenu from './SettingsMenu';
import { notifMng } from '../notifications/api';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function HeaderBar(props) {
  const { config } = props;
  const classes = useStyles();
  const history = useHistory();
  const [openNotifications, setOpenNotifications] = React.useState(false);
  const [openSettings, setOpenSettings] = React.useState(false);
  const [
    unreadNotificationsCount,
    setUnreadNotificationsCount,
  ] = React.useState(undefined);

  const fetchNotificationsUnreadCount = async () => {
    try {
      const unreadNotifs = await notifMng.fetchUnreadNotificationsCount();
      setUnreadNotificationsCount(unreadNotifs);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!App.opts.disableUserAccount) {
      App.eventsManager.on('event-user-loaded', HeaderBar, fetchNotificationsUnreadCount);
    }
  }, []);

  const openNotificationsDialog = () => {
    setOpenNotifications(true);
  };

  const onLogoClick = () => {
    const { eventsManager } = App;
    if (eventsManager.hasListeners('event-open-about')) {
      eventsManager.emit('event-open-about', HeaderBar.name);
    } else {
      window.location.reload(true);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        className={'app-header'}
        elevation={0}
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
          color: '#fff',
          height: '48px',
          minHeight: '48px',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
        <Toolbar
          variant="dense"
          style={{
            minHeight: '48px',
            height: '48px',
            paddingLeft: '16px',
            paddingRight: '8px',
          }}>
          <div className={classes.title} style={{ display: 'flex', alignItems: 'center' }}>
            {props.backUrl && (
              <IconButton
                onClick={() => {
                  history.push(props.backUrl);
                }}
                edge="start"
                size="small"
                style={{ marginRight: '8px', color: '#fff' }}
                aria-label="menu">
                <MdArrowBack size={18} />
              </IconButton>
            )}
            {props.icon && (
              <span style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
                {props.icon}
              </span>
            )}
            {props.title ? (
              <span style={{ fontSize: '15px', fontWeight: 600 }}>
                {props.title}
              </span>
            ) : (
              <span
                onClick={() => onLogoClick()}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  height: '48px',
                  lineHeight: '48px',
                }}>
                {config.title}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {!App.opts.disablePulseIndicator && <PulseIndicator />}
            {!config.disableNotifications && (
              <IconButton
                size="small"
                style={{ color: '#fff', padding: '6px' }}
                onClick={() => openNotificationsDialog()}>
                <Badge
                  badgeContent={
                    unreadNotificationsCount > 0
                      ? unreadNotificationsCount
                      : undefined
                  }
                  variant={'standard'}
                  color="error">
                  <FaBell size={18} />
                </Badge>
              </IconButton>
            )}
            <SettingsMenu
              open={openSettings}
              onClose={() => setOpenSettings(false)}
            />
          </div>
        </Toolbar>
      </AppBar>
      <NotificationsDialog
        open={openNotifications}
        onClose={() => {
          setOpenNotifications(false);
        }}
      />
    </div>
  );
}

HeaderBar.propTypes = {
  title: PropTypes.object,
  backUrl: PropTypes.string,
  config: PropTypes.object,
};
